/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const r=(()=>{const r=new ArrayBuffer(4),n=new Uint8Array(r);return new Uint32Array(r)[0]=1,1===n[0]})();export{r as isPlatformLittleEndian};
